import { Component, OnInit, Input } from "@angular/core";
import { Observable } from "rxjs";
import { CustomerService } from "./../../../../../services/login.service";
import { UserInfoModel } from "src/app/interfaces/UserInfo.model";
import { Keywords } from "src/app/enums/kewords.enum";

@Component({
  selector: "user-profile",
  templateUrl: "./user-profile.component.html",
  styleUrls: ["./user-profile.component.css"]
})
export class UserProfileComponent implements OnInit {
  // Public properties
  //user$: Observable<User>;
  user$: Observable<any>;

  @Input() avatar: boolean = true;
  @Input() greeting: boolean = true;
  @Input() badge: boolean;
  @Input() icon: boolean;
  UserImage : string ;
  userInfo : UserInfoModel =JSON.parse(sessionStorage.getItem(Keywords.USER_INFO));
  currentLanguage:string=''

  /**
   * Component constructor
   */
  constructor(private customerService: CustomerService,
    ) {}

  ngOnInit(): void {
    this.currentLanguage=localStorage.getItem('language')
  }

 /**
   * Log out
   */
  logout() {
    this.customerService.logout();
  }
  changeLanguage(language){
    localStorage.setItem('language',language)
    this.currentLanguage=language
    document.location.reload () 
  }


  EditAccount(){
    let UserDetailes = sessionStorage.getItem("UserDetailes");
    UserDetailes = JSON.parse(UserDetailes);

  }
}
